export { default } from './FullScreenModalLayoutContent';
